import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { Constants, getCourseCategoryLabel } from "@eagerdog/constants";
import { helperService } from "src/services/helper.service";
import { ICourseSummary } from "@eagerdog/interfaces";

import Chip from "src/components/Chip/Chip";
import Course from "src/routes/Course/Course";

import styles from "./CourseCard.module.scss";
import { Modal, useModal } from "../Modal/Modal";

interface IProps {
    isAdmin?: boolean;
    course: ICourseSummary;
}

const CourseCard: React.FC<IProps> = (props) => {
    const { toggle, isShown } = useModal();

    const courseModalContent = (
        <React.Fragment>
            <div className={"scrollWrap"}>
                <Course cid={props.course.handle} />
            </div>
        </React.Fragment>
    );

    const getButtonText = () => {
        if (props.course.course_type === Constants.course_type.seminar) {
            return "View Seminar";
        } else if (props.course.course_type === Constants.course_type.drop_in) {
            return "View Class";
        }
        return "View Course";
    };

    const getCourseTypeLabel = () => {
        if (props.course.course_type === Constants.course_type.seminar) {
            return "Seminar";
        } else if (props.course.course_type === Constants.course_type.drop_in) {
            return "Class";
        }
        return "Course";
    };

    return (
        <div className={styles.CourseCard}>
            <div className={styles.courseType}>{getCourseTypeLabel()}</div>
            <div className={styles.title} onClick={(e) => { window.history.pushState("", "", "/c/" + props.course.handle); toggle(); }}>{props.course.title}</div>
            <div className={styles.club}>{props.course.club.club_name}</div>
            <div className={styles.label}><span className={`${styles.status} ${styles[props.course.status.toLowerCase()]}`}>{helperService.getEventStatus(props.course.status)}</span></div>
            <div className={styles.date}><div className={`${styles.icon} ${styles.calendar}`}></div><span>{moment(props.course.start_date).format("MMM D, YYYY, h:mma")}</span></div>
            <div className={styles.address}><div className={`${styles.icon} ${styles.location}`}></div><span>{helperService.formatAddress(props.course.club.address)}</span></div>
            <div className={styles.chips}>
                {props.course.course_type === Constants.course_type.drop_in
                    ? <Chip>Ongoing</Chip>
                    : props.course.schedule.length > 1
                        ? <Chip>{props.course.schedule.length.toString()} Sessions</Chip>
                        : <Chip>Single Session</Chip>
                }
                {props.course.category && <Chip>{getCourseCategoryLabel(props.course.category)}</Chip>}
            </div>
            <div className={styles.fee}>
                {props.course.fee != null ? <><span className={styles.dollarSign}>$</span><div className={styles.amount}>{props.course.fee}</div></> : "No Price Set"}
            </div>
            <div className={styles.currency}>total, priced in {props.course.currency?.toUpperCase()}</div>
            <div className={styles.actions}>
                <Link className={styles.viewCourse} to={`/c/${props.course.handle}`}>{getButtonText()}</Link>
            </div>
            <Modal
                className={"courseModal"}
                isShown={isShown}
                hide={() => {
                    toggle();
                    window.history.pushState("", "", "/courses");
                }}
                expand={true}
                modalContent={courseModalContent}
            />
        </div>
    );
};

export default CourseCard;